import { useEffect } from 'react';
import { refreshThisDeviceSubscription } from './subscription';

export function useSubscriptionRefresh(): void {
  useEffect(() => {
    void refreshThisDeviceSubscription();

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        void refreshThisDeviceSubscription();
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => document.removeEventListener('visibilitychange', onVisibilityChange);
  }, []);
}
